module.exports = __webpack_public_path__ + "img/sacco4.49c91b91.png";